import { useState } from 'react';
import { onboardUser } from '../utils/apiCalls';
import Modal from './Modal';

export default function OnboardUser({ isOpen, onClose, clinicId, locationId, token, onSuccess }) {
    const initialFormData = { full_name: '', email: '', role: 'user' }
    const [formData, setFormData] = useState(initialFormData);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');


    //  handle change for form fields
    const handleChange = (event) => {
        let { name, value } = event.target;

        setFormData({ ...formData, [name]:value });
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    // Validate phone/email 
    const validateField = (name, value) => {
        setError('');

        if (!value) {
            switch (name) {
                case 'full_name':
                    setError('Please fill out Name');
                    break;
                case 'email':
                    setError('Please enter a valid email address');
                    break;
                default:
                    setError('');
                    break;
            }
        } else {
            switch (name) {
                case 'email':
                    if (!emailRegex.test(value)) {
                        setError('Please enter a valid email address');
                    }
                    break;
                default:
                    setError('');
                    break; 
            }
        }
    };

    const handleBlur = (event) => {
        const { name, value } = event.target;
        validateField(name, value);
    }

    const handleValidate = () => {
        // let valid = true;
        setError('');

        if (!formData.full_name) {
            setError('Name is required');
            return false;
        }
        else if (!formData.email ||!emailRegex.test(formData.email)) {
            setError('Valid email address is required');
            return false;
        }
        return true;
        
    }

    const handleSubmit = async (event) => {
    event.preventDefault();
    if (!handleValidate()) return;

        setLoading(true);
        setError('');

        const payload = { full_name: formData.full_name, location_id: formData.role === 'admin' ? null : locationId, clinic_id: clinicId, email: formData.email, role: formData.role};
        console.log('Onboard payload:', payload);

        try {
            const result = await onboardUser(payload, token );
            console.log('ONBOARD RESULT', result);
            if (!result?.username) {
                throw new Error('User record was not created');
            }
            setFormData(initialFormData);
            onClose();
            if (onSuccess) onSuccess();
            } catch (error) {
                setError(error.message || 'Failed to onboard user');
            } finally {
                setLoading(false);
            }
        }

    if (!isOpen) return null;

    return (
        <Modal >
            <h2 className="text-xl font-bold text-docpgrPurple mb-4">
                Onboard User
            </h2>

            {error && <p className="text-red-500 mb-2">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
                {/* name  */}
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Full Name
                    </label>
                    <input type='text' name='full_name' value={formData.full_name} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>
                {/* email  */}
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Email
                    </label>
                    <input type='email' name='email' value={formData.email} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>
                {/* {userRole === 'super_admin' && (
                <div>
                    <label className='block text-sm font-medium mb-1'>
                        Role
                    </label>
                    <select value={formData.role} name='role' onChange={handleChange} onBlur={handleBlur} className='w-full border rounded p-2'>
                        <option value='user'>User</option>
                        <option value='admin'>Admin</option>
                    </select>
                </div>
                )} */}

                <div className='flex justify-end gap-2'>
                    <button type='button' onClick={onClose} className='px-4 py-2 rounded border text-gray-700 hover:bg-gray-100'>
                        Cancel
                    </button>
                    <button type='submit' disabled={loading} className='px-4 py-2 rounded border bg-docpgrPurple text-white hover:bg-docpgrPurple90'>
                        { loading ? 'Onboarding...' : 'Onboard' }
                    </button>
                </div>
            </form>
        </Modal>
    )
}